import { StaffRole } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getAllRoles(): Promise<StaffRole[]> {
    try {
        const response = await portalApi.get('/roles')
        return response.data;
    } catch (error) {        
        console.error('Error fetching staff roles:', error);
        throw error;
    }
}

export async function getMyActualRoles(): Promise<string[]> {
    try {
        const response = await portalApi.get('/me/roles')
        const roles: string[] = response.data.map((role: { code: string }) => role.code);
        return roles;
    } catch (error) {        
        console.error('Error fetching my actual roles:', error);
        throw error;
    }
}

export async function getRolesForStaff(initials: string) {
    try {
        const response = await portalApi.get<StaffRole[]>(`/staff/${initials}/roles`)
        return response.data;
    } catch (error) {        
        console.error(`Error fetching roles for staff with initials: ${initials}`, error);
        throw error;
    }
}
